import React from 'react';
import { Link } from '@reach/router';
import { NavBar } from './../../Components/NavBar';
import { LazyImage } from './../../Components/LazyImage';
import { BlockGrid } from './../../Components/BlockGrid';
import { CenteredContainer } from './../../Components/CenteredContainer';
import { StaggeredAnimation } from './../../Components/StaggeredAnimation';
import { LazyP5Sketch } from '../../Backgrounds/LazyP5Sketch';
import { noiseWaveSketch } from './../../Backgrounds/noiseWaveSketch';
import pages from './../../Services/pages';
import './Styles/Play.css';

export class Play extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projects: []
    };
    this.parts = [
      '...makes David a dull boy? Not quite... In fact, I quite enjoy what I do so the line between work and play tends to be rather blurry.',
      "Below you can find a cherry-picked list of projects I've worked on over the years, to give an idea of the variety of tools and technologies I've been tinkering with after hours."
    ];
    this.BG = LazyP5Sketch(noiseWaveSketch);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.projectStore
      .getProjects()
      .then(result => this.fillProjects(result))
      .catch(e => {
        console.error(e);
      });
  }

  render() {
    return (
      <div>
        {this.BG}
        <NavBar pages={pages} active="play" />
        <div className="Play">
          <CenteredContainer ratio="90%" maxWidth="50em">
            <div className="Title">
              <div className="Title__work">
                <span>All</span> Work
              </div>
              <div className="Title__play">
                & No <span>Play</span>
                ...
              </div>
            </div>
            <div style={{ marginBottom: '1em' }}>
              <StaggeredAnimation
                items={this.parts}
                renderItem={this.renderPart}
                animation="fadeInLeft"
                startHidden={true}
                duration={0.3}
                initialDelay={0.1}
                incrementalDelay={0.05}
              />
            </div>
          </CenteredContainer>
          <BlockGrid
            maxWidth="940px"
            maxItemWidth="450px"
            items={this.state.projects}
            renderItem={this.renderProject}
          />
        </div>
      </div>
    );
  }

  fillProjects = projects => {
    this.setState({ projects: projects });
  };

  renderProject = project => {
    return (
      <div className="Play__Project">
        <LazyImage
          image={project.titleImg}
          size={{ width: 448, height: 100 }}
          alt="Project title"
        />
        <div className="Project__Title">{project.title}</div>
        <div className="Project__Description">{project.shortDescription}</div>
        <Link to={project.id}>read more...</Link>
      </div>
    );
  };

  renderPart = part => {
    return <div className="Subtext">{part}</div>;
  };
}
